import { useUserAttributes } from '@/features/miiaFw/composables/useUserAttributes'

export const useRouterUtils = () => {
  const { getUserAttributesFromStore } = useUserAttributes()

  /**
   * 認証済みであるかの状態を取得する
   * ※miiaFwStoreのisAuthorizedではリロード時等では正確に取得できないため、
   *   ユーザ属性が取得できるかどうかで判定
   * @returns {Promise<boolean>} true:認証済、false:未認証
   */
  const getAuthorized = async (): Promise<boolean> => {
    try {
      // ユーザ属性を取得
      const attributes = await getUserAttributesFromStore()
      return attributes !== undefined
    } catch {
      return false
    }
  }

  return {
    getAuthorized
  }
}
